module.exports = __webpack_public_path__ + "static/media/aribaTransparent.cfec452c.png";